import axios from 'axios';

const excuseApi = async (configs) => {
  let { path, method, body, prefix, extraHeaders, responseType, params } = configs;
  if (!prefix) {
    prefix = process.env.REACT_APP_API_PREFIX;
  }

  if (!extraHeaders) {
    extraHeaders = {};
  }

  const token = localStorage.getItem('token');
  if (token) {
    extraHeaders.Authorization = `Bearer ${token}`;
  }

  // Handle content type
  let contentType = 'application/json';
  if (extraHeaders['Content-Type']) {
    contentType = extraHeaders['Content-Type'];
    // Remove it from extraHeaders to avoid duplication
    delete extraHeaders['Content-Type'];
  }

  const options = {
    method,
    url: `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PREFIX}${path}`,
    headers: {
      ...extraHeaders,
    },
    responseType: responseType || 'json',
    params,
  };

  // Handle body based on content type
  if (body) {
    if (body instanceof FormData) {
      // For FormData, let axios set the content type with boundary
      options.data = body;
    } else if (contentType === 'application/json') {
      options.data = JSON.stringify(body);
      options.headers['Content-Type'] = contentType;
    } else {
      options.data = body;
      options.headers['Content-Type'] = contentType;
    }
  } else {
    // If there's no body, still set the Content-Type
    options.headers['Content-Type'] = contentType;
  }
  try {
    const response = await axios.request(options);
    return response;
  } catch (error) {
    console.error("API Error:", {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : null
    });

    throw error;
  }
}

export {
  excuseApi,
};
